import { useAdminUpdate } from '@reapitform/hooks'
import { AdminReviewCardSection, AdminReviewCardSectionPayload } from '../types'

/** Updates a section (`PUT /api/review-cards/{reviewCardRef}/sections/{sectionRef}`). */
export const useUpdateAdminReviewCardSection = (reviewCardReferenceID: string, sectionReferenceID: string) =>
  useAdminUpdate<AdminReviewCardSectionPayload, AdminReviewCardSection>({
    path: `/api/review-cards/${reviewCardReferenceID}/sections/${sectionReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the section',
    successMessage: 'Section updated',
  })
